import { Stack, styled } from '@healthinal/ui';
import { theme } from '../theme.ts';

export const StickyContainer = styled(Stack)({
  position: 'sticky',
  zIndex: 100,
  top: 0,
  backgroundColor: theme.vars.palette.background.body,
});
